import { ReactElement } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { WithEmployerHeaderLayout } from '@/components/layouts'
import CustomHead from '@/components/molecules/CustomHead'
import AtsIntegrationTemplate from '@/components/templates/AtsIntegration'

export default function Pricing() {
  const { t } = useTranslation('forEmployers')
  return (
    <>
      <CustomHead
        metaData={{
          title: t('atsIntegrationTitle'),
          description: t('atsIntegrationSubititle'),
        }}
      />
      <AtsIntegrationTemplate />
    </>
  )
}

Pricing.getLayout = function getLayout(page: ReactElement) {
  return <WithEmployerHeaderLayout>{page}</WithEmployerHeaderLayout>
}
